import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../../helpers/Helpers';
import { MenuComponent } from '../../../../_metronic/assets/ts/components';
import { KTCard } from '../../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../../_metronic/helpers/components/KTCardBody';
import Content from '../../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator } from '../../../../redux/reducers/authSlice';
import TableFooter from '../../../../components/TableFooter';
import { ColumnChooserModel } from '../../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../../components/ColumnFilter/kolonBirlestir';
import { buildExcelRequest, ExcelExportMode } from '../../../../helpers/excelExportRequest';
import { ToolbarWrapper } from '../../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../../components/RefreshButton';
import { useSortableColumns } from '../../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions, ColumnFilterOption } from '../../../../components/ColumnFilter/ColumnFilterTypes';
import { ColumnFilterModel } from '../../../../models/common/ColumnFilterModel';
import { FARKLI_DOVIZ } from '../../../../helpers/dipToplam';
import { HGS_SAYFASI, HgsToplamlari, HgsKaydi, HgsListIstegi, HgsOgsService, HgsSecenek, HgsSecenekleri, ilkHgsListIstegi, ISLEM_TURU, tutarYaz } from '../../../../services/HgsOgsService';
import HgsOgsListFilters from './Components/HgsOgsListFilters';
import ExcelIceAktarModal from './Components/ExcelIceAktarModal';

/**
 * Genel Giderler > HGS Kayıtları (26.10.2026, #101): standart liste ekranı. Giriş / çıkış tarih-saat-yer ve işletme (otoyol) kolonları;
 * işlem tarihi = giriş tarihi. #101'deki panel filtreleri (plaka,
 * tarih aralığı, geçiş türü) 22.09.2026 standardına göre kolon filtresi; arama kutusu sefer no arar.
 * Excel'den içe aktarma ve örnek Excel (#488) araç çubuğunda.
 */
const HgsOgsList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const pageName = HGS_SAYFASI
    const pageVersion = "1";
    const [data, setData] = useState<{ list: HgsKaydi[], totalRecordCount: number, toplamlar?: HgsToplamlari }>({ list: [], totalRecordCount: 0 });
    const [filter, setFilter] = useState<HgsListIstegi>(ilkHgsListIstegi)
    const [iceAktarAcik, setIceAktarAcik] = useState<boolean>(false);

    const getColumns = () => {
        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        var list: ColumnChooserModel[] = [
            { title: 'İşlem Türü', name: 'islemTuruAdi', order: 0, isVisible: true },
            { title: 'Plaka', name: 'plaka', order: 0, isVisible: true },
            { title: 'Araç Cinsi', name: 'aracCinsi', order: 0, isVisible: true },
            { title: 'Giriş Tarihi', name: 'islemTarihiStr', order: 0, isVisible: true },
            { title: 'Giriş Saati', name: 'islemSaati', order: 0, isVisible: true },
            { title: 'Giriş Yeri', name: 'girisYeri', order: 0, isVisible: true },
            { title: 'Çıkış Tarihi', name: 'cikisTarihiStr', order: 0, isVisible: true },
            { title: 'Çıkış Saati', name: 'cikisSaati', order: 0, isVisible: true },
            { title: 'Çıkış Yeri', name: 'cikisYeri', order: 0, isVisible: true },
            { title: 'İşletme', name: 'isletme', order: 0, isVisible: true },
            { title: 'Geçiş Türü', name: 'gecisTuru', order: 0, isVisible: false },
            { title: 'Ücret', name: 'tutar', order: 0, isVisible: true, className: 'text-end' },
            { title: 'Döviz', name: 'dovizCinsi', order: 0, isVisible: true },
            { title: 'TL Karşılığı', name: 'tutarTL', order: 0, isVisible: true, className: 'text-end' },
            { title: 'Maliyet (TL)', name: 'maliyetTL', order: 0, isVisible: false, className: 'text-end' },
            { title: 'Sefer No', name: 'seferNo', order: 0, isVisible: true },
            { title: 'Etiket No', name: 'etiketNo', order: 0, isVisible: false },
            { title: 'Kaynak', name: 'kaynakAdi', order: 0, isVisible: true },
            { title: 'Açıklama', name: 'aciklama', order: 0, isVisible: false }
        ];

        for (var i = 0; i < list.length; i++)
            list[i].order = i + 1;

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => getData({ ...filter, currentPage: i, skip: (i - 1) * filter.take });

    const changeTake = (_take: number) => getData({ ...filter, currentPage: 1, skip: 0, take: _take });

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    const updateKayit = async (_id: string | undefined = undefined) => {
        navigate('/hgsogs/listadd?id=' + (_id ? _id : data.list.filter(x => x.isSelected)[0].hgsOgsKaydiId));
    }

    const deleteKayit = async () => {
        try {
            dispatch(storeActivityIndicator(true))

            var response = await HgsOgsService.sil(data.list.filter(x => x.isSelected).map(x => x.hgsOgsKaydiId));

            if (!response.isSuccess) {
                toast.error(response.message ?? '')
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success('Seçilen kayıtlar silindi.')

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: HgsListIstegi | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response = await HgsOgsService.getList(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data ?? { list: [], totalRecordCount: 0 });
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            list: data.list.map(function (x) {
                if (x.hgsOgsKaydiId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.list.length == data.list.filter(x => x.isSelected).length;

        setData({
            ...data,
            list: data.list.map(function (x) {
                x.isSelected = !isAllSelected;
                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData({ ...filter, currentPage: 1, skip: 0 });
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response = await HgsOgsService.exportList(buildExcelRequest(filter, mode, data.list.filter(x => x.isSelected).map(x => x.hgsOgsKaydiId), columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const ornekExcel = async () => {
        try {
            dispatch(storeActivityIndicator(true))

            var response = await HgsOgsService.ornekExcel();

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Seçimli kolon filtrelerinin seçenekleri tek istekte gelir; ilk açılan kolon yükler, diğerleri hatırlar.
    const secenekler = useRef<Promise<HgsSecenekleri> | undefined>(undefined);

    const secenekYukle = (al: (s: HgsSecenekleri) => HgsSecenek[]) => async (): Promise<ColumnFilterOption[]> => {
        if (!secenekler.current)
            secenekler.current = HgsOgsService.secenekler().then(r => {
                if (!r.isSuccess)
                    throw r.message;
                return r.data as HgsSecenekleri;
            });

        try {
            return al(await secenekler.current).map(x => ({ value: x.value, label: x.label }));
        } catch (error: any) {
            secenekler.current = undefined;
            toast.error(error);
            return [];
        }
    }

    const plakaYukle = async (): Promise<ColumnFilterOption[]> => {
        var response = await HgsOgsService.plakalar();

        return response.isSuccess ? (response.data as HgsSecenek[]).map(x => ({ value: x.value, label: x.label })) : [];
    }

    // Kolon adları backend'deki eşlemeyle (HgsOgsListe) aynı.
    const sortableColumns = ['islemTuruAdi', 'plaka', 'etiketNo', 'maliyetTL', 'aracCinsi', 'islemTarihiStr', 'islemSaati', 'girisYeri', 'cikisTarihiStr', 'cikisSaati', 'cikisYeri', 'isletme', 'gecisTuru', 'tutar', 'dovizCinsi', 'tutarTL', 'seferNo'];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    const columnFilterDefinitions: ColumnFilterDefinitions = {
        islemTuruAdi: { type: 'select', allowEmpty: false, loadOptions: () => Promise.resolve([
            { value: String(ISLEM_TURU.GECIS), label: 'Geçiş' },
            { value: String(ISLEM_TURU.YUKLEME), label: 'Yükleme' },
            { value: String(ISLEM_TURU.IADE), label: 'İade' },
            { value: String(ISLEM_TURU.DUZELTME), label: 'Düzeltme' }
        ]) },
        plaka: { type: 'select', allowEmpty: false, loadOptions: plakaYukle },
        aracCinsi: { type: 'text' },
        islemTarihiStr: { type: 'date' },
        islemSaati: { type: 'text' },
        girisYeri: { type: 'text' },
        cikisTarihiStr: { type: 'date' },
        cikisSaati: { type: 'text' },
        cikisYeri: { type: 'text' },
        isletme: { type: 'select', loadOptions: secenekYukle(s => s.isletmeler) },
        gecisTuru: { type: 'select', loadOptions: secenekYukle(s => s.gecisTurleri) },
        tutar: { type: 'number' },
        dovizCinsi: { type: 'select', allowEmpty: false, loadOptions: secenekYukle(s => s.dovizCinsleri) },
        tutarTL: { type: 'number' },
        maliyetTL: { type: 'number' },
        seferNo: { type: 'text' },
        etiketNo: { type: 'text' },
        kaynakAdi: { type: 'text' },
        aciklama: { type: 'text' },
    };

    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: HgsKaydi, column: string, className: string | undefined) => {
        var item2: any = item;
        var deger = item2[column];

        if (column == 'tutar' || column == 'tutarTL' || column == 'maliyetTL')
            deger = tutarYaz(deger);
        else if (column == 'islemTuruAdi' && item.islemTuru != ISLEM_TURU.GECIS)
            deger = <span className={'badge ' + (item.islemTuru == ISLEM_TURU.YUKLEME ? 'badge-light-primary' : 'badge-light-warning')} title={item.islemTuru == ISLEM_TURU.YUKLEME ? 'Bakiye yükleme maliyete girmez' : undefined}>{item.islemTuruAdi}</span>;
        else if (column == 'plaka' && !item.plaka && item.hamPlaka)
            deger = item.hamPlaka;

        return <td className={className} onClick={() => setItemSelected(item.hgsOgsKaydiId)} onDoubleClick={() => updateKayit(item.hgsOgsKaydiId)}>{deger}</td>;
    }

    // Dip toplam (Ambar listesi gibi): filtrelenmiş bütün kayıtlar; farklı döviz varsa ücret toplamı yazılmaz.
    const getTotalValue = (column: string, columnIndex: number, className: string | undefined) => {
        const t = data.toplamlar;

        if (columnIndex == 0)
            return <td className={className}>Toplam</td>;

        if (column == 'tutar')
            return <td className={className}>{!t ? '' : t.farkliDoviz ? FARKLI_DOVIZ : tutarYaz(t.tutar)}</td>;

        if (column == 'dovizCinsi')
            return <td className={className}>{t && !t.farkliDoviz ? t.dovizCinsi : ''}</td>;

        if (column == 'tutarTL')
            return <td className={className}>{t ? tutarYaz(t.tutarTL) : ''}</td>;

        if (column == 'maliyetTL')
            return <td className={className} title='Geçiş +, İade −, Düzeltme işaretli; Yükleme maliyete girmez'>{t ? tutarYaz(t.maliyetTL) : ''}</td>;

        return <td className={className}></td>;
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <HgsOgsListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    setFilter={setFilter}
                    selectedCount={data.list.filter(x => x.isSelected).length}
                    onSearchSubmit={onSearchSubmit}
                    deleteFunction={deleteKayit}
                    updateFunction={updateKayit}
                    iceAktar={() => setIceAktarAcik(true)}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.list.length > 0 && data.list.filter(x => x.isSelected).length == data.list.length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.list.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.list.map((item) =>
                                            <tr key={item.hgsOgsKaydiId} style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                            <input onChange={() => setItemSelected(item.hgsOgsKaydiId)} className='form-check-input' type='checkbox' checked={!!item.isSelected} />
                                                        </label>
                                                    </div>
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column) => (
                                                        <React.Fragment key={column.name}>{getColumnValue(item, column.name, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>

                                {
                                    data.list.length > 0 && (
                                        <tfoot>
                                            <tr className='fw-bolder text-gray-800'>
                                                <td style={{ width: 1 }}></td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment key={column.name}>{getTotalValue(column.name, columnIndex, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        </tfoot>
                                    )
                                }
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.list.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>

            <ExcelIceAktarModal
                show={iceAktarAcik}
                onClose={() => setIceAktarAcik(false)}
                onAktarildi={() => { setIceAktarAcik(false); getData({ ...filter, currentPage: 1, skip: 0 }); }}
                ornekExcel={ornekExcel}
            />
        </React.Fragment>
    )
}

export default HgsOgsList;
